import { render, staticRenderFns } from "./basicContainer.vue?vue&type=template&id=b44d77f4&scoped=true"
import script from "./basicContainer.vue?vue&type=script&lang=js"
export * from "./basicContainer.vue?vue&type=script&lang=js"
import style0 from "./basicContainer.vue?vue&type=style&index=0&id=b44d77f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44d77f4",
  null
  
)

export default component.exports